import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import globalVariables from "GlobalVariable";

// --- Importaciones para la funcionalidad de login ---
import { useAuth } from "context/AuthContext"; // Importamos el hook useAuth

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // Estado para el menú móvil
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false); // Estado para el menú de perfil
  const { user, logout } = useAuth(); // Obtenemos el usuario y la función de logout del contexto
  const navigate = useNavigate();
  const profileMenuRef = useRef(null); // Ref para el menú de perfil

  // Cierra el menú de perfil si se hace clic fuera de él
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
        setIsProfileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  // Función para manejar el clic en los enlaces de sección y hacer scroll
  const handleScrollToSection = (event, sectionId) => {
    event.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMobileMenuOpen(false);
    }
  };

  // Función para manejar el logout
  const handleLogout = () => {
    logout();
    navigate("/"); // Redirigimos al inicio después del logout
    setIsMobileMenuOpen(false);
    setIsProfileMenuOpen(false);
  };


  return (
    <header className="fixed w-full bg-white shadow-md z-30">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <a
              href="/"
              className="text-2xl font-bold text-pink-600 cursor-pointer"
            >
              <img
                src="https://samedaypet.s3.amazonaws.com/ba4faeb5-cc14-4e69-8846-204001c9f41f.png"
                alt="Azúcar Multimedia"
                className="h-12"
              />
            </a>
          </div>

          {/* --- Botón Menú Móvil --- */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-800 focus:outline-none"
              aria-label="Toggle mobile menu"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMobileMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>

          {/* --- Navegación de Escritorio --- */}
          <nav className="hidden md:flex items-center space-x-8">
            {/* <a
              href="#services"
              onClick={(e) => handleScrollToSection(e, "services")}
              className="text-gray-800 hover:text-red-600 font-medium cursor-pointer"
            >
              Services
            </a>
            <a
              href="#clients"
              onClick={(e) => handleScrollToSection(e, "clients")}
              className="text-gray-800 hover:text-red-600 font-medium cursor-pointer"
            >
              Clients
            </a>
            <a
              href="#contact"
              onClick={(e) => handleScrollToSection(e, "contact")}
              className="text-gray-800 hover:text-red-600 font-medium cursor-pointer"
            >
              Contact
            </a> */}

            {/* --- Lógica condicional para los botones --- */}
            {!user ? (
              <>
                <Link
                  to="https://dashboard.azucarai.com"
                  className="text-gray-800 hover:text-red-600 font-medium"
                >
                  Login
                </Link>
                <Link
                  to="https://dashboard.azucarai.com/signup"
                  className="bg-gray-800 text-white font-medium px-4 py-2 rounded-lg hover:bg-gray-700 transition-colors"
                >
                  Sign Up
                </Link>
                {/* <Link
                  to="/login?demo=true"
                  style={{ background: "#DC2626" }}
                  className="text-white font-medium px-4 py-2 rounded-lg hover:bg-pink-700 transition-colors flex items-center gap-2"
                >
                  Demo
                </Link> */}
              </>
            ) : (
              // --- Menú de Perfil para Usuario Logueado ---
              <div className="relative" ref={profileMenuRef}>
                <button
                  onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
                  className="flex items-center justify-center w-10 h-10 bg-gray-200 rounded-full text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                >
                  {/* Icono de Usuario SVG */}
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </button>

                {isProfileMenuOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-xl z-20 py-1">
                    <Link
                      to="/dashboard_client" // O la ruta que corresponda
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      onClick={() => setIsProfileMenuOpen(false)}
                    >
                      Dashboard
                    </Link>
                    <button
                      onClick={handleLogout}
                      className="w-full text-left block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Logout
                    </button>
                  </div>
                )}
              </div>
            )}
          </nav>
        </div>

        {/* --- Menú Móvil --- */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200">
            {/* <a href="#services" onClick={(e) => handleScrollToSection(e, "services")} className="block py-2 text-gray-800 hover:text-red-600 cursor-pointer">Services</a>
            <a href="#clients" onClick={(e) => handleScrollToSection(e, "clients")} className="block py-2 text-gray-800 hover:text-red-600 cursor-pointer">Clients</a>
            <a href="#contact" onClick={(e) => handleScrollToSection(e, "contact")} className="block py-2 text-gray-800 hover:text-red-600 cursor-pointer">Contact</a>
            <div className="border-t my-2"></div> */}

            {/* --- Lógica condicional para el menú móvil --- */}
            {!user ? (
              <>
                <Link to="https://dashboard.azucarai.com" className="block py-2 text-gray-800 hover:text-red-600" onClick={() => setIsMobileMenuOpen(false)}>Login</Link>
                <Link to="https://dashboard.azucarai.com/signup" className="block py-2 text-gray-800 hover:text-red-600" onClick={() => setIsMobileMenuOpen(false)}>Sign Up</Link>
                {/* <Link to="/login?demo=true" className="block py-2 text-red-600 font-medium" onClick={() => setIsMobileMenuOpen(false)}>Demo</Link> */}
              </>
            ) : (
              <>
                <Link to="/dashboard_client" className="block py-2 text-gray-800 hover:text-red-600" onClick={() => setIsMobileMenuOpen(false)}>Dashboard</Link>
                <button onClick={handleLogout} className="w-full text-left block py-2 text-red-600 font-medium">Logout</button>
              </>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
